<template>
    <div id="visitorMailList">
        <a-spin :spinning="loading">
            <div style="display: flex">
                <VisitorMailBox
                    class="col-md-3"
                    @visible-composer="
                        (e) => {
                            isVisibleComposer = e;
                        }
                    "
                    @mailDetails="(e) => (mailDetails = e)"
                    :isGetChat="isGetChat"
                    :visitorMail="this.visitorMail"
                />
                <MailComposer
                    v-if="isVisibleComposer"
                    @closeEditor="isVisibleComposer = false"
                    style="width: calc(100% - 400px)"
                    :isNewMail="true"
                    :isVisitorDetail="true"
                    :mailDetails="mailDetails"
                    @newMailDetail="(e) => (newMailDetail = e)"
                />

                <NoMessage
                    v-if="!isVisibleComposer && mailDetails.length === 0"
                    :desc="$t('mail.mailNotFound')"
                    newMail="true"
                    @newComposer="isVisibleComposer = true"
                    class="empty-mail"
                />

                <ThreadViewer
                    v-if="!isVisibleComposer && mailDetails.length > 0"
                    style="height: calc(100vh - 200px)"
                    class="col-md-9"
                    :composerView="isVisibleComposer"
                    :mailDetails="mailDetails"
                />
            </div>
        </a-spin>
    </div>
</template>

<script>
import { log2 } from "../../../utils/log2";
import { mapActions, mapState } from "vuex";
import VisitorMailBox from "./VisitorMailBox.vue";
import MailComposer from "../Mail/MailComposer.vue";
import ThreadViewer from "../Mail/ThreadViewer.vue";
import MailComposerMail from "../Mail/MailComposer.vue";
import NoMessage from "../Mail/NoMessage.vue";

const log = log2("VisitorMailList");

export default {
    name: "VisitorMailList",
    components: {
        NoMessage,
        MailComposerMail,
        VisitorMailBox,
        MailComposer,
        ThreadViewer,
    },
    props: {
        visitorId: {
            type: String,
        },
        visitorMail: {
            type: String,
        },
        isGetChat: {
            type: Boolean,
            default: false,
        },
    },
    data: () => {
        return {
            loading: false,
            allMailCounts: 0,
            unreadMails: [],
            isVisibleComposer: false,
            mailDetails: [],
            newMailDetail: [],
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            emailSendSuccess: (state) => state.mail.emailSendSuccess,
        }),
    },
    methods: {
        ...mapActions({
            getVisitorMailList: "mail/getVisitorMailList",
        }),
    },
    mounted() {
        return this.getVisitorMailList({
            visitorId: this.$route.params.visitorId || this.visitorId,
            mailAddress: this.visitorMail,
            pageCount: 1,
            perPage: 20,
        }).then((response) => {
            this.allMailCounts = response.count || 0;
            this.unreadMails = response.mails.filter((x) => !!x.isUnread).map((x) => x.lastMail) || 0;
            return response.mails.map((x) => x.lastMail) || [];
        });

        window.addEventListener("keydown", (e) => {
            if ("Escape" === e.key || "Esc" === e.key) {
                this.isVisibleComposer = false;
            }
        });
    },
    watch: {
        newMailDetail(val) {
            this.mailDetails = val;
        },
        emailSendSuccess(val) {
            this.$message.destroy();
            this.$message.success("Mail başarıyla gönderildi.", 3);
        },
    },
};
</script>

<style lang="scss">
#visitorMailList {
    .empty-mail {
        justify-content: center;
        width: 100%;
        display: flex;
        align-items: center;
        margin-top: 130px;
        width: 100%;
    }
}
</style>
